import {
  EnvironmentOutlined,   // GIS / Map
  DashboardOutlined,     // Dashboard
  FormOutlined,          // Forms
  TeamOutlined,          // Users
} from "@ant-design/icons";

import { NavLink } from "react-router-dom";

import "./NavigationRail.css";

function NavigationRail() {
  return (
    <div className="navigation-rail">
      <NavLink to="/" className="nav-btn" title="GIS">
        <EnvironmentOutlined />
      </NavLink>

      <NavLink to="/dashboard" className="nav-btn" title="Dashboard">
        <DashboardOutlined />
      </NavLink>

      <NavLink to="/schemes" className="nav-btn" title="Schemes">
        <FormOutlined />
      </NavLink>

      <NavLink to="/users" className="nav-btn" title="Users">
        <TeamOutlined />
      </NavLink>
    </div>
  );
}

export default NavigationRail;